import { render } from "./msgSendStatus.vue?vue&type=template&id=39aabcfe&scoped=true"
import script from "./msgSendStatus.vue?vue&type=script&lang=js"
export * from "./msgSendStatus.vue?vue&type=script&lang=js"

import "./msgSendStatus.vue?vue&type=style&index=0&id=39aabcfe&lang=scss&scoped=true"

import exportComponent from "/Users/tangyinbo/workspace/front/syb/syb_webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39aabcfe"]])

export default __exports__